import { render, staticRenderFns } from "./SaleDetails.vue?vue&type=template&id=754dd818&scoped=true&"
import script from "./SaleDetails.vue?vue&type=script&lang=ts&"
export * from "./SaleDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SaleDetails.vue?vue&type=style&index=0&id=754dd818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754dd818",
  null
  
)

export default component.exports